import { CustomElement } from '@aurelia/runtime-html';
export const name = "db-autocomplete-filter";
export const template = "<cds-autocomplete\n    ref=\"dbAutocompleteFilter\"\n    label.bind=\"label\"       \n    itemselected.trigger=\"handleItemSelected($event)\"\n    ...$attrs\n></cds-autocomplete>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
